import { useEffect, useState } from 'react';
import { CtPrivacyRepository } from 'common/api/models';
import { getToken, refreshToken } from './keycloak';

export const useFetch = (endPoint, options) => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async () => {
      let authHeader = {};

      if (CtPrivacyRepository.isPrivate()) {
        await refreshToken();
        authHeader = { Authorization: `Bearer ${getToken()}` };
      }

      const headers = new Headers({
        Accept: 'application/json',
        ...authHeader,
        ...options?.headers,
      });

      const request = new Request(endPoint, {
        ...options,
        headers: headers,
        signal: controller.signal,
      });

      try {
        const response = await fetch(request);
        const data = await response.json();

        setIsLoading(false);
        setData(data);
      } catch (error) {
        if (!controller.signal.aborted) {
          setError(error);
          setIsLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      controller.abort();
    };
  }, [endPoint, options]);

  return { data, isLoading, error };
};
